
'use client';

import {
	Box,
	Button, Card, Flex, For, Skeleton, Stack,
} from '@chakra-ui/react';
import { CartItemTable, CartSummaryCard, CartSummaryDetail } from '../../components';

import { APP_ROUTES } from '@/routes';
import { Link } from '@packages/chakra-v3';
import { useTranslations } from 'next-intl';
import { useCartActions, useCart } from '../../hooks';
import { DefaultStyle } from '@packages/wastic-shared';
import { PromotionCard, PromotionTooltip } from '@/modules/promotions';

const CartContainer = () => {
	const t = useTranslations('CartPage.cartSummary');
	const {
		isLoading, cartItems, cartSummary, itemCount, promotions,
	} = useCart();
	const { handleUpdateCartItem, handleRemoveCartItem } = useCartActions();

	return (
		<Flex flexDir={'row'} flexWrap={'wrap'} gap={DefaultStyle.TIGHT_SECTION_GAP}>
			<Stack flex={2} gap={DefaultStyle.TIGHT_SECTION_GAP}>
				<Card.Root>
					<Card.Body p={4}>
						<CartItemTable
							isEditable
							cartItems={cartItems}
							isLoading={isLoading}
							onClickRemoveCartItem={handleRemoveCartItem}
							onClickUpdateCartItem={handleUpdateCartItem}
						/>
					</Card.Body>
				</Card.Root>
				<Card.Root pb={4}>
					<Card.Header>
						<Flex alignItems={'center'}>
							<Card.Title textStyle={'h6'}>
								Available Promotion
							</Card.Title>
							<PromotionTooltip />
						</Flex>
					</Card.Header>
					<Card.Body p={4}>
						<Stack gap={DefaultStyle.SMALL_GAP}>
							<For each={promotions} >
								{promotion => <PromotionCard key={promotion.id} promotion={promotion} />}
							</For>
						</Stack>
					</Card.Body>
				</Card.Root>
			</Stack>
			<Box flex={1} flexShrink={0} w={'250px'}>
				<CartSummaryCard >
					{isLoading && <Skeleton height={50} />}
					{cartSummary && itemCount && (
						<Stack gap={12}>
							<CartSummaryDetail
								beforeDiscount={cartSummary.beforeDiscount}
								finalPrice={cartSummary.finalPrice}
								itemCount={cartSummary.itemCount}
								memberDiscount={cartSummary.memberDiscount}
								promotionDiscount={cartSummary.promotionDiscount}
								shippingFee={cartSummary.shippingFee}
							/>
							{itemCount <= 10
								? (
									<Button asChild>
										<Link href={APP_ROUTES.PAYMENT.CHECKOUT}>{t('checkout')}</Link>
									</Button>
								)
								: t('cartOver')}
						</Stack>
					)}
				</CartSummaryCard>
			</Box>
		</Flex>
	);
};

export default CartContainer;
